import { render, staticRenderFns } from "./IDCardFHIS.vue?vue&type=template&id=70b88690&scoped=true&"
import script from "./IDCardFHIS.vue?vue&type=script&lang=js&"
export * from "./IDCardFHIS.vue?vue&type=script&lang=js&"
import style0 from "./IDCardFHIS.vue?vue&type=style&index=0&id=70b88690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b88690",
  null
  
)

export default component.exports